module.exports = __webpack_public_path__ + "media/images/resource/bwif_logo-db0e12f63c26b79114a852c161dd3036.png";